<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title" @click="$emit('clicked', index)">
          <font-awesome-icon
            class="collapse"
            :icon="selected ? 'angle-down' : 'angle-left'"
          />
          <div class="text-center text-padding">
            {{ item.State }}
          </div>
        </v-card-title>
        <div>
          <app-row icon="globe" title="کشور مقصد:" :value="item.Country" />
        </div>
        <div v-if="selected">
          <app-row
            icon="hashtag"
            title="شماره درخواست:"
            :value="item.RequestID"
          />
          <app-row icon="calendar-alt" title="تاریخ:" :value="dateRange" />
          <div style="padding: 15px">
            <v-row align="center">
              <v-col class="d-flex">
                <b>موافقت مدرسه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.StateSchool }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>موافقت مرکز:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex content">
                {{ item.StateCenter }}
              </v-col>
            </v-row>
            <v-row v-if="item.Removable" class="ltr">
              <v-btn
                color="red white--text"
                class="register"
                rounded
                @click="$emit('removeRequest', item.RequestID)"
              >
                حذف درخواست
              </v-btn>
            </v-row>
            <div style="padding:5px"></div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedItem"],
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>


.register {
  margin: 20px 20px 0 20px !important;
}
</style>
